<template>
  <wz-modal :value="value" @input="$emit('input', $event)"
            size="sm" title="Anular registros" :close-on-overlay="false" @close="onClose">
    <p v-if="entityDescription && !isBatch" class="mb-2 text-sm">{{ entityDescription }}</p>

    <template v-if="isBatch">
      <p class="mb-2 text-sm"><strong>Se anularán {{ entityDescriptions.length }} registros:</strong></p>
      <ul class="annul-list mb-3">
        <li v-for="(d, i) in entityDescriptions" :key="i" class="text-sm">{{ d }}</li>
      </ul>
    </template>

    <wz-alert variant="danger" icon="ri-error-warning-line" class="mb-3">
      Esta acción es irreversible.
    </wz-alert>

    <wz-textarea
      v-model="reason"
      label="Motivo de la anulación"
      placeholder="Explica por qué se anula (mínimo 10 caracteres)"
      :rows="3"
      required
    />
    <small class="text-muted d-block">{{ reason.trim().length }}/10 mínimo</small>

    <template #footer>
      <wz-button variant="outline" @click="$emit('input', false)">Cancelar</wz-button>
      <wz-button variant="danger" :disabled="!valid || submitting" @click="confirm">
        {{ submitting ? 'Anulando...' : 'Anular' }}
      </wz-button>
    </template>
  </wz-modal>
</template>

<script>
// Modal reutilizable para "Anular por error" (Vacaciones / Licencias / DMs). Emite `confirm` con el
// motivo validado; el padre invoca su propio service (VacationService/LeaveService/MedicalLeaveService).
export default {
  name: 'AnnulByMistakeModal',
  props: {
    value: { type: Boolean, default: false },
    entityDescription: { type: String, default: '' },
    entityDescriptions: { type: Array, default: () => [] },
    submitting: { type: Boolean, default: false },
  },
  data() {
    return { reason: '' }
  },
  computed: {
    valid() {
      return this.reason.trim().length >= 10
    },
    isBatch() {
      return Array.isArray(this.entityDescriptions) && this.entityDescriptions.length > 0
    },
  },
  watch: {
    value(open) {
      if (open) this.reason = '' // limpia al abrir
    },
  },
  methods: {
    confirm() {
      if (!this.valid) return
      this.$emit('confirm', this.reason.trim())
    },
    onClose() {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="stylus" scoped>
.annul-list
  max-height 180px
  overflow-y auto
  padding-left 1.1rem
  margin 0
  li
    margin-bottom 2px
</style>
